module.exports = __webpack_public_path__ + "static/media/ic_cell_regular.b20f9670.svg";